export default "__VITE_ASSET__62ee1988__"